import { render, staticRenderFns } from "./ToplamERPSiparisTutari.vue?vue&type=template&id=059d0f74&scoped=true"
import script from "./ToplamERPSiparisTutari.vue?vue&type=script&lang=js"
export * from "./ToplamERPSiparisTutari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059d0f74",
  null
  
)

export default component.exports